import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLogout = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 31,
	viewBox: "0 0 32 31",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M24.5 9L22.385 11.115L26.255 15H11V18H26.255L22.385 21.87L24.5 24L32 16.5M5 6H17V3H5C3.35 3 2 4.35 2 6V27C2 28.65 3.35 30 5 30H17V27H5V6Z",
		fill: "currentColor"
	})
});
export default SvgLogout;
